/**
 * Типы экшенов thunk-ов статуса документа (documentInfoThunks.ts).
 * Вынесены отдельно, чтобы authSlice обрабатывал их, не импортируя сами
 * thunk-и: иначе в любую сборку с авторизацией попадал бы код рерайта.
 */
export const DOCUMENT_STATUS_ACTION_PREFIX = 'auth/loadDocumentStatus';
export const DOCUMENT_INFO_REFRESH_ACTION_PREFIX = 'auth/refreshDocumentInfo';
